import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@progress/kendo-react-inputs';
import './Checkbox.scss';

/**
 * Checkbox
 * @module
 * @param {string} name - Specifies the name property of the input DOM element
 * @param {func} onChange - Function invoked on checkbox change
 * @param {bool} [value] - Current checkbox value
 * @param {bool} [disabled] - Readonly checkbox
 * @param {string} [label] - Label text
 * @param {number} [tabIndex] - Checkbox tabindex
 */

const CheckboxComponent = (props) => {
  return (
    <Checkbox 
      className={`checkbox ${props.disabled ? 'disabled-field' : ''} `}
      name={props.name}
      onChange={(e) => props.onChange(props.name, e.value)}
      value={props.value}
      disabled={props.disabled}
      label={props.label}
      tabIndex={props.tabIndex}
    />
  );
};


CheckboxComponent.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  tabIndex: PropTypes.number
}

export default CheckboxComponent;